export default {
    BjDialogListConfig: {
        // code: '商品编码',
        // name: '商品名称',
        orderNo: '订单号',
        POCode: '入库单号',
        POShippingMethod: '运输方式',
        POContainerId: '集装箱号',
        POStatus: '状态',
        classification: '商品分类',
        entercode: '请输入编码',
        entername: '请输入名称',
        selectcategory: '请选择分类',
        SKUcode: 'SKU',
        SKUname: '产品名称',
        Producttype: '商品类型',
        // enterproductname: '请输入商品名称',
        // enterproductcode: '请输入商品编码',
        enterSKUcode: '请输入SKU编码',
        Storecode: '店铺编码',
        Storename: '店铺名称',
        Storetype: '店铺类型',
        Codes: '编码',
        Names: '名称',
        Saleschannel: '销售渠道',
        Types: '类型',
        enteronlinestorecode: '请输入网店编码',
        enteronlinestorename: '请输入网店名称',
        selectchannel: '请选择渠道',
        Warehousecode: '仓库编码',
        Warehousename: '仓库名称',
        Warehouseaddress: '仓库地址',
        Internalordernumber: '内部订单号',
        Thirdordernumber: '客户订单号',
        Ordertype: '订单类型',
        Orderstatus: '订单状态',
        Salesstore: '销售店铺',
        Paymentstatus: '支付状态',
        Itemquantity: '商品行数量',
        goodsamount: '商品总金额',
        TotalOrderAmount: '订单总金额',
        Buyerpayable: '买家应付',
        goodscost: '商品总成本',
        Buyerpayment: '买家实付',
        Shipmentstatus: '发货状态',
        Receivingstatus: '收货状态',
        Buyernickname: '买家昵称',
        Consigneename: '收货人姓名',
        Phone: '手机号',
        Shippingaddress: '收货地址',
        Threepartyorder: '三方下单时间',
        Paymenttime: '支付时间',
        Creationtime: '创建时间',
        Tripartitenumber: '客户订单号/内部订单号',
        TripartiteId: '客户订单ID/WMS ID',
        WMSOrderNo:'WMS订单号',
        giftor: '是否赠品',
        Circulationstatus: '流转状态',
        Writestatus: '回写状态',
        Platformstatus: '平台收货状态',
        itemsNumber: '商品数',
        Discounttotal: '优惠合计',
        Totalamount: '应收总金额',
        Merchantamount: '商家承担优惠金额',
        preferentialamount: '三方承担优惠金额',
        Orderpulling: '拉单时间',
        Suppliercode: '供应商编码',
        Suppliername: '供应商名称',
        Suppliercommodity: '供应商商品编码',
        Pricetax: '含税价',
        Taxrate: '税率',
        entersuppliercode: '请输入供应商编码',
        entersuppliername: '请输入供应商名称',
        Available: '可用库存',
        Number: '采购在途数',
        Minimum: '最小采购量',
        Purchaseorder: '采购单号',
        Purchasetype: '采购类型',
        Warehousingstatus: '入库状态',
        Receivingwarehouse: '收货仓库',
        Purchasequantity: '采购数量',
        Receiptquantity: '入库数量',
        Quantityreceived: '未入库数量',
        Stopwaiting: '停止等待数量',
        Operationtime: '操作时间',
        Operator: '操作人',
        Operationtype: '操作类型',
        Remarks: '备注',
    },
    ExcelConfig: {
        Title: '导入',
        Import: 'Excel导入规则说明：',
        AfterDownload: 'Excel模板下载后，系统会进行自动匹配，如果系统已经自动匹配，将按导入内容覆盖匹配关系；',
        ImportExcel: 'Excel导入模板，点击下载：',
        Download: '模板下载',
        MustHave: '导入Excel格式必须带标题，红色标题为必填；',
        MustBe: 'Excel模块导入后，将按导入内容覆盖原订单信息；',
        Supports: '支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过6万行，如果超过，请分成多次导入。',
        maximum: '上传文件大小最大不能超过128M',
        maximum2: '上传文件大小最大不能超过30M',
        Confirm: '确认导入',
        submitted: '文件已提交，可前往 导入历史 页面查看导入结果',
        failedTemplate: '获取模板失败',
        upload: '请先上传文件',
        excelNumberLimit: 'excel数据最多为200条，请先进行分割处理',
        numberError: '列号错误',
        nameError: '列名错误',
        integerTip: '需要为整数',
        numberTip: '需要为浮点数',
        stringTip: '需要为字符串',
        emptyTip: '不能为空',
        excelEroorTip: '文件中存在无效数据，请下载反馈文件查看新增的错误列，并在原始文件中修改。',
        excelEroorTip1: '文件中存在无效数据。',
        excelEroorTip2: '请下载反馈文件，查看系统新增的错误提示列，',
        excelEroorTip3: '并在原始文件中修改后重新上传。',
        tip1: '必须为整数且不能为0',
        tip2: '必须为整数，或小数，且不能为0',
        tip3: 'Barcode 不允许超过14位字符，或包含空格，特殊字符',
        tip4: '不能带有空格',
        tip5: '请确认州的填写正确。例如使用缩写NSW，VIC等',
        downTip1: '下载并填写标准的商品信息模板。系统将在导入时自动匹配各字段。如检测到已存在的商品匹配关系，本次导入的数据将覆盖原有内容。',
        downTip2: '点击「模板下载」按钮，下载标准商品导入模板。',
        downTip3: '导入的 Excel 文件必须包含表头。蓝色标注的字段为必填项。',
        downTip4: '支持的文件格式：CSV、XLS、XLSX。单个文件大小不得超过 128MB，数据行数不得超过 60,000 行。若超出限制，请拆分文件后分批导入。',
        downTip5: '将文件拖拽至上传区域，或点击「上传」按钮选择文件。',
    }
};
